/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { getCaseLink, getProductData } from "../productService";
import { AbstractCase } from "../../types/Entities/AbstractCase";
import { ExtraContent } from "./StatusBox/ExtraContent";
import { getButton, getContent as getContentLitigationCase, getPercentage as getPercentageLitigationCase } from "../litigationCase/statusBoxSteps";
import {
  STATUS_ADMINISTRATIVE_PROCEEDINGS,
  STATUS_ADMINISTRATIVE_DECISION_ISSUED,
  STATUS_EXTRAJUDICIAL_COMMUNICATION_SENT,
  STATUS_EXTRAJUDICIAL_REACTION_RECEIVED,
  STATUS_ACTION_REQUIRED,
  STATUS_PREPARE_LAWSUIT,
} from "./leadStatus";

export const getContent = (administrativeLawLitigationCase: AbstractCase) => {
  switch (administrativeLawLitigationCase.leadStatus) {
    case STATUS_ADMINISTRATIVE_PROCEEDINGS:
      return {
        header: "Schreiben an die Gegenseite",
        text:
          "Wir haben ein Schreiben an die Gegenseite geschickt und informieren Sie umgehend, sobald die Gegenseite " +
          "auf das Schreiben reagiert. Sollte keine Reaktion stattfinden, kommen wir auf Sie zu, um Ihre Möglichkeiten" +
          " zu besprechen.",
      };
    case STATUS_ADMINISTRATIVE_DECISION_ISSUED:
      return {
        header: "Der Bescheid liegt vor",
        text: "Bitte prüfen Sie den Bescheid und teilen Sie uns mit, wie Sie weiter vorgehen möchten.",
        buttonTarget: getCaseLink(administrativeLawLitigationCase) + "/rueckmeldung-bescheid",
        buttonLabel: "Vorgehen festlegen",
      };
    case STATUS_EXTRAJUDICIAL_COMMUNICATION_SENT:
      return {
        header: "Widerspruch an Behörde",
        text:
          "Wir haben den Widerspruch an die Behörde geschickt und informieren Sie umgehend, sobald die Behörde" +
          "auf den Widerspruch reagiert. Sollte keine Reaktion erfolgen, kommen wir auf Sie zu, um Ihre Möglichkeiten " +
          "– wie etwa eine Untätigkeitsklage – zu besprechen. ",
      };
    case STATUS_EXTRAJUDICIAL_REACTION_RECEIVED:
    case STATUS_ACTION_REQUIRED:
      if (administrativeLawLitigationCase.administrativeCaseType === "expeditedProceeding") {
        return {
          header: "Wir bereiten die nächsten Schritte vor",
          text: "Wenn es Neuigkeiten gibt oder wir Informationen von Ihnen benötigen, informieren wir Sie umgehend.",
        };
      }
      if (administrativeLawLitigationCase.administrativeCaseType === "failureToActLawsuit") {
        return {
          header: "Untätigkeitsklage",
          text: "Wir prüfen das weitere Vorgehen. Für Sie ist aktuell nichts weiter zu tun.",
        };
      }
      return {
        header: "Die Reaktion der Behörde liegt vor",
        text: "Bitte prüfen Sie hier die Reaktion der Behörde und teilen Sie uns mit, wie sie weiter vorgehen möchten.",
      };
    case STATUS_PREPARE_LAWSUIT:
      const litigationContent = getContentLitigationCase(administrativeLawLitigationCase);

      if (administrativeLawLitigationCase.administrativeCaseType === "expeditedProceeding") {
        return {
          ...litigationContent,
          header: "Ihr Eilantrag wird vorbereitet",
        };
      }

      return litigationContent;
    default:
      return getContentLitigationCase(administrativeLawLitigationCase);
  }
};

export const getPercentage = (litigationCase: AbstractCase) => {
  switch (litigationCase.leadStatus) {
    case STATUS_ADMINISTRATIVE_PROCEEDINGS:
    case STATUS_ADMINISTRATIVE_DECISION_ISSUED:
      return 60;
    default:
      return getPercentageLitigationCase(litigationCase);
  }
};

export const getStatusBoxConfigCivilServiceLaw = (civilServiceLawCase: AbstractCase) => {
  const content = getContent(civilServiceLawCase);
  return {
    header: content.header,
    text: content.text,
    ctaButton: getButton(civilServiceLawCase),
    productName: getProductData(civilServiceLawCase.name, "label"),
    percentage: getPercentage(civilServiceLawCase),
    extraContent: <ExtraContent litigationCase={civilServiceLawCase} />,
  };
};
